export const SUBMIT_ANALYTICS_BY_USER_ACTION_REQUESTED = "SUBMIT_ANALYTICS_BY_USER_ACTION_REQUESTED";
export const SUBMIT_ANALYTICS_BY_USER_ACTION_DISPATCHER = "SUBMIT_ANALYTICS_BY_USER_ACTION_DISPATCHER";
export const SUBMIT_ANALYTICS_BY_USER_ERROR_DISPATCHER = "SUBMIT_ANALYTICS_BY_USER_ERROR_DISPATCHER";
export const ANALYTICS_BY_USER_LOADING = "ANALYTICS_BY_USER_LOADING";

//Action Creator
export const submitAnalyticsByUserAction = (data) => ({
  type: SUBMIT_ANALYTICS_BY_USER_ACTION_REQUESTED,
  postData: data,
});

//Action Dispatcher
export const submitAnalyticsByUserActionDispatcher = (data) => ({
  type: SUBMIT_ANALYTICS_BY_USER_ACTION_DISPATCHER,
  payload: data,
});

export const submitAnalyticsByUserErrorDispatcher = (data) => ({
  type: SUBMIT_ANALYTICS_BY_USER_ERROR_DISPATCHER,
  payload: data,
});

export const analyticsByUserLoading = (loading) => ({
  type: ANALYTICS_BY_USER_LOADING,
  payload: loading,
});

